import Vue from 'vue'
import IconButton from '@/components/IconButton.vue'

Vue.component('IconButton', IconButton)
